import { Injectable } from '@angular/core'

import { BackgroundScreenCredentialItem } from '../models/background-screen-credential-item'
import { CredentialItem } from '../models/credential-item'
import { EligibilityCredential, Organization } from '../../models'
import { EligibilityRule } from '../../models/eligibility-rule-set'
import { DefaultedCredentialItem } from '../models/defaulted-credential-item'
import { FifaCredentialItem } from '../models/fifa-credential-item'
import { LitmosCredentialItem } from '../models/litmos-credential-item'
import { MembershipCredentialItem } from '../models/membership-credential-item'
import { ProofOfBirthCredentialItem } from '../models/proof-of-birth-credential-item'
import { SafesportCredentialItem } from '../models/safesport-credential-item'
import { SidelineCredentialItem } from '../models/sideline-credential-item'
import { ViolationCredentialItem } from '../models/violation-credential-item'
import { ElectronicDocumentCredentialItem } from '../models/electronic-document-credential-item'

@Injectable({
  providedIn: 'root'
 })
export class CredentialItemFactory {

  public create(rule: EligibilityRule, credential: EligibilityCredential, organization: Organization): CredentialItem {
    const args = { rule, credential, organization }
    switch (rule.originator_type) {
      case 'background_screen': return new BackgroundScreenCredentialItem(args)
      case 'fifa_integration': return new FifaCredentialItem(args)
      case 'membership_definition': return new MembershipCredentialItem(args)
      case 'proof_of_birth': return new ProofOfBirthCredentialItem(args)
      case 'safesport': return new SafesportCredentialItem(args)
      case 'sideline_sports': return new SidelineCredentialItem(args)
      case 'violation_review': return new ViolationCredentialItem(args)
      case 'waiver': return new ElectronicDocumentCredentialItem(args)
      case 'electronic_document': return new ElectronicDocumentCredentialItem(args)
      case 'course-C01': return new LitmosCredentialItem(args)
      default: return new DefaultedCredentialItem(args)

    }
  }

}
